import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import * as FiIcons from "react-icons/fi";

import SafeIcon from "../../common/SafeIcon";

const { FiLoader, FiRefreshCw } = FiIcons;

export default function AuthenticationLoadingScreen() {
  const [showReloadButton, setShowReloadButton] =
    useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowReloadButton(true);
    }, 5000);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-4">
      <div className="flex flex-col items-center gap-6">
        <div className="relative flex h-20 w-20 items-center justify-center overflow-hidden rounded-[24px] bg-slate-900 shadow-2xl">
          <div className="absolute inset-0 animate-pulse bg-gradient-to-tr from-emerald-500/20 to-transparent" />

          <SafeIcon
            icon={FiLoader}
            className="relative z-10 animate-spin text-4xl text-white"
          />
        </div>

        <div className="text-center">
          <p className="mb-2 text-[10px] font-black uppercase tracking-[0.4em] text-slate-400">
            ProfitYo AI System
          </p>

          <p className="animate-pulse text-sm font-medium text-slate-600">
            Loading your workspace...
          </p>
        </div>

        {showReloadButton && (
          <motion.button
            type="button"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            onClick={() => window.location.reload()}
            className="mt-8 flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-xs font-semibold text-slate-600 hover:text-slate-900"
          >
            <SafeIcon icon={FiRefreshCw} />
            Trouble loading? Reload App
          </motion.button>
        )}
      </div>
    </div>
  );
}